var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "justify-space-around": "" } },
        [
          _c(
            "v-flex",
            {
              attrs: { xs3: "", sm2: "", md2: "", "text-xs-center": "" },
              on: { click: _vm.showDialog }
            },
            [
              _c(
                "time",
                {
                  staticClass: "icon",
                  staticStyle: { margin: "auto", "margin-bottom": "5px" },
                  attrs: { datetime: _vm.submission.sessionDate }
                },
                [
                  _c(
                    "em",
                    {
                      class: {
                        "red--text": _vm.submission.needLevel === "ABSENT"
                      }
                    },
                    [_vm._v(_vm._s(_vm.date.year))]
                  ),
                  _vm._v(" "),
                  _c(
                    "strong",
                    {
                      class: {
                        month: _vm.submission.needLevel !== "ABSENT",
                        "month-absent": _vm.submission.needLevel === "ABSENT"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.date.month) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.date.date))])
                ]
              ),
              _vm._v(" "),
              _vm.submission.needLevel === "ABSENT"
                ? _c("span", { staticClass: "red--text" }, [_vm._v("ABSENT")])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "pt-1" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("militaryTimeToStandard")(
                        _vm.submission.sessionTime
                      )
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _vm.submission.sessionMinutes
                ? _c("span", [
                    _c("small", [
                      _vm._v(
                        "(" + _vm._s(_vm.submission.sessionMinutes) + " mins)"
                      )
                    ])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              attrs: { "text-xs-left": "", xs8: "" },
              on: { click: _vm.showDialog }
            },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "font-weight-bold",
                          class: { "body-2": _vm.isMobile }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.submission.studentFirstName) +
                              "\n            " +
                              _vm._s(_vm.submission.studentLastName) +
                              "\n            (" +
                              _vm._s(_vm.submission.studentExtId) +
                              ")\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { class: { caption: _vm.isMobile } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.submission.studentSchoolName) +
                            " (" +
                            _vm._s(_vm.submission.grade) +
                            ")\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { class: { caption: _vm.isMobile } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.submission.locationName) +
                            "\n            "
                        ),
                        _vm.submission.locationOther
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.submission.locationOther) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.submission.hasAttachments
                            ? _c("v-icon", [_vm._v("attach_file")])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      class: { "pt-3": _vm.isMobile },
                      attrs: { xs12: "", sm6: "" }
                    },
                    [
                      _c("div", { class: { caption: _vm.isMobile } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.submission.planTypeName) +
                            "\n            " +
                            _vm._s(_vm.submission.serviceType) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { class: { caption: _vm.isMobile } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("formatDate")(
                                _vm.submission.serviceStartDate
                              )
                            ) +
                            "\n            -\n            " +
                            _vm._s(
                              _vm._f("formatDate")(
                                _vm.submission.serviceEndDate
                              )
                            ) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.submission.serviceEsy
                        ? _c("div", { class: { caption: _vm.isMobile } }, [
                            _vm._v("(ESY)")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { class: { caption: _vm.isMobile } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.submission.providerFirstName +
                                " " +
                                _vm.submission.providerLastName
                            ) +
                            "\n            "
                        ),
                        _vm.submission.providerCredential
                          ? _c("span", [
                              _vm._v("\n              /\n              "),
                              _vm.isMobile
                                ? _c("span", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.submission.providerCredentialType
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.submission.providerCredential
                                        ) +
                                        "\n              "
                                    )
                                  ])
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm2: "" } },
            [
              _c("action-icons", {
                attrs: { submission: _vm.submission },
                on: { "service-log:deleted": _vm.deleteServiceLog }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.confirmationDialog
        ? _c(
            "div",
            [
              _c("submission-history", {
                attrs: { submission: _vm.submission },
                on: {
                  "dialog:closed": function($event) {
                    _vm.confirmationDialog = false
                  },
                  "reload:page": _vm.deleteServiceLog
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db279d1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db279d1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/history/history-repeatable/history-repeatable.vue
// module id = null
// module chunks = 